import React from 'react'
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import NavBar from '../components/Navbar';
import QuestionsGrid from '../components/QuestionsGrid';
import Sidebar from '../components/Sidebar';

const Questions = () =>  {
    const [isOpen, setIsOpen] = useState(false)

    const toggle =() =>{
      setIsOpen(!isOpen)
    };

    return (

        <body class="">
            
         <div class="wrapper">
            <Sidebar isOpen={isOpen} toggle={toggle}/>
            <NavBar toggle={toggle}/>
            <motion.div 
                layout
                initial={{opacity:0}}
                animate={{opacity:1}}
                transition={{delay:1}}>

                <div class='container hero'>
                    <h1>Questions?</h1>
                    <h2>These are questions we get asked by artists, sellers and just <span class="highlight">EVERYONE</span></h2>
                </div>
            </motion.div>

            <QuestionsGrid/>
         </div>
        </body>
    )
}

export default Questions;
